(function ($, Cobalt, undefined) {
    Cobalt.WarningNotification =
    {
        initialize: function () {
            // Warning Acknowledgement
            var userIdCookie = Cobalt.User.ID;
            var warningThrottleCookie = $.cookie('WarningNotification.Lock');
            if (userIdCookie && !warningThrottleCookie) {
                var date = new Date();
                date.setTime(date.getTime() + (5 * 60 * 1000));
                $.cookie('WarningNotification.Lock', 1, { expires: date, path: "/" });
                var width = 500;
                var height = 320;

                $.get(Cobalt.Routes.Instance.UserWarningAcknowledgementModal(), function (data) {
                    if (!data.length) {
                        return;
                    }
                    Cobalt.Modal.openModal(Cobalt.Routes.Instance.UserWarningAcknowledgementModal(),
                        undefined, width, height, 'p-warning-ack-modal', false, false, width, width, height, false);
                });
                
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.WarningNotification.js